import { render } from "./registration.vue?vue&type=template&id=21d789bd&ts=true"
import script from "./registration.vue?vue&type=script&lang=ts"
export * from "./registration.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\01.Works\\BoonRock\\114.X1Studio\\001.PMS\\31.Dev\\99_source\\crm-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__